import { useTranslation } from "react-i18next";
import { Text } from "@/components/ui/Text";
import { Badge } from "@/components/ui/badge";
import type { CreativeItemCardsProps } from "@/types/creative-library";
import { PrivateImage } from "./PrivateImage";

export function CreativeItemCards({
  items,
  brands,
  board,
  onDetail,
}: CreativeItemCardsProps) {
  const { t } = useTranslation("app");
  return (
    <>
      {items.map((item) => (
        <button
          key={item.token}
          type="button"
          className="flex flex-col overflow-hidden rounded-2xl border border-border bg-background text-left transition-colors hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          onClick={() => onDetail(item)}
          data-testid={`creative-item-card-${item.token}`}
        >
          <PrivateImage
            source={item.mediaUrl}
            alt={item.title}
            className="aspect-[4/3] w-full object-contain rounded-none"
          />
          <div className="flex flex-1 flex-col gap-2 p-4">
            <Text size="sm" className="truncate font-normal">
              {item.title}
            </Text>
            <Text size="xs" color="muted" className="truncate">
              {[
                brands.find((brand) => brand.token === item.brandToken)?.name,
                t(`creativeLibrary.origin.${item.origin}`),
              ]
                .filter(Boolean)
                .join(" · ")}
            </Text>
            <div className="mt-auto flex flex-wrap gap-1.5">
              {board && (
                <Badge variant="outline">
                  {t(
                    board.definition.referenceTokens.includes(item.token)
                      ? "creativeLibrary.boardReference"
                      : "creativeLibrary.boardOutput",
                  )}
                </Badge>
              )}
              <Badge variant="secondary">
                {t(`creativeLibrary.roles.${item.role}`)}
              </Badge>
              <Badge variant="outline">
                {t(`creativeLibrary.sharing.${item.sharingMode}`)}
              </Badge>
            </div>
          </div>
        </button>
      ))}
    </>
  );
}
